import { app } from '../../../app';

app.component('spHeaderSupportLinks', {
    templateUrl: require('./sp-header-support-links.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-header/sp-header-support-links/sp-header-support-links.component.js